export const identifiersStatuses = {
  completed: 'completed',
  missing: 'missing',
  partial: 'partial',
}

export const itemIdentifierLabels = {
  barcode: 'Código de barras',
  ns_pid: 'NS-PID',
  mid_code: 'MID',
  hts_code: 'Código HTS',
}

export const usCountryCode = 'US'
